/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';
import {SegmentResource} from '../../components/api/resources/resource/segment.resource';

@Component({
  standalone: false,
  selector: 'adn-segment-route-page',
  template: `
    <adn-segment-list-page
      *ngIf="list"
      [list]="list">
    </adn-segment-list-page>
  `
})
export class SegmentRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(SegmentResource) private readonly Segment: any
  ) {
  }

  ngOnInit(): void {
    this.adnListHelper.setUpList(this.list, this.Segment, false, 'fullSegmentList', {
      baseTable: 'segment'
    });
  }
}
